import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-confirm-duplication-dialog',
  standalone: false,
  templateUrl: './confirm-duplication-dialog.component.html',
  styleUrl: './confirm-duplication-dialog.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDuplicationDialogComponent {
  mej = '';
  description = '';
  isCapexActiveStage = false;
  selectedCapexOption: 'toMej' | 'keepCapex' | null = null;

  constructor(
    private dialogRef: MatDialogRef<ConfirmDuplicationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data.mej) {
      this.mej = data.mej;
    }
    if (data.description) {
      this.description = data.description;
    }
    if (data.isCapexActiveStage) {
      this.isCapexActiveStage = data.isCapexActiveStage;
    }
  }

  onProceed(): void {
    if (this.isCapexActiveStage) {
      if (!this.selectedCapexOption) return;
      this.dialogRef.close({ choice: this.selectedCapexOption });
    } else {
      this.dialogRef.close({ duplicate: true });
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
